import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router'
import tripNotFound from '../../../assets/images/icons/trip-not-found.svg'
export default function ErrorPage() {
  const navigate = useNavigate()

  return (
    <div>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <img src={tripNotFound} alt="trip-not-found"></img>
        <p className="title2">Trip not found</p>
        <p className="body2">
          We looked but cannot find this trip. Please check if the link is
          right.
        </p>
      </div>
    </div>
  )
}
